import {OneCustomerBaseURL as BaseURL} from ".";
import {post} from "../../common/fetch";
import {PasswordResetInput, AccountAPI} from "../domain/account";

export default class OneCustomerAccountAPI implements AccountAPI {
  async initPasswordReset(input: PasswordResetInput): Promise<void> {
    return post<void>(`${BaseURL}/passwordreset`, input);
  }
}
